<template>
  <div class="storeorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="order-tab">
      <span @click="toggle(1)" :class="{curt:1==active}">已付款</span>
      <span @click="toggle(2)" :class="{curt:2==active}">已完成</span>
    </div>
    <div style="height:55px"></div>
    <div class="order-item" v-for="(item,i) in order">
      <div class="title">
        <div class="address">{{item.name}}</div>
        <div class="make" :style="item.status == 0 ? 'color:red' : ''">{{item.status == 0 ? '未付款' : item.status == 1 ? '已付款' : '已归还'}}</div>
      </div>
      <div class="product">
        <div class="goods">
          <div class="left" :style="'background:url('+baseUrl+item.image+') no-repeat center;background-size:100%'"></div>
          <!--<img class="left" :src="baseUrl+item.image" />-->
          <div class="right">
            <p>{{item.title}}</p>
            <div class="num">数量：{{item.num}}件</div>
            <div class="price">
              <i>￥</i><b>{{item.price.split(".")[0]}}</b>
              <i>.{{item.price.split(".")[1]}}</i>
            </div>
          </div>
        </div>
        <div class="names">
          <div class="timer">购买时间：{{item.createtime}}</div>
          <div class="timer" >订单编号：{{item.number}}</div>
        </div>
      <div class="rylcjs" @click="codes(item.id)" v-if="item.status == 1">立即验收 <img src="~assets/images/icon5.png"></div>
      <div class="rylcjs" @click="toPush(item.id,'warestore')" v-if="item.status == 2">查看验收结果 <img src="~assets/images/icon5.png"></div>
      </div>
    </div>  
    <div class="none"  v-if="order.length <= 0 ">
      <img src="~assets/images/no.png">
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        active:1,
        baseUrl:'',
        dialogFormVisible:false,
        order_id:0
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getOrder();
    },

    methods: {
      toggle(index){
        this.active=index;
        this.getOrder();
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      backTop:function(){
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getOrder:function(){
        var that = this;
        var id = that.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/store/goodsOrder',
          params:{
            goods_id:id,
            status:that.active
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.order = res
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      codes:function(order_id){
        window.location.href="http://user.4008005216.com/main/ware?id="+order_id
      }
    }
  };
</script>

<style>
  
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-message{
    top:auto !important;
    bottom:20px !important;
    min-width:70% !important;
  }
  .el-message{
    transition: opacity .3s,transform .4s,bottom .4s !important;
  }
  .el-dialog{
    width:90% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .storeorderApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-bottom:5px
  }
  .storeorderApp .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:0;
    background:#f7faff;
    z-index:99
  }
  .storeorderApp .order-tab span{
    display:inline-block;
    width:20%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    font-weight:bold;
    color:#666;
    position:relative;
  }
  .storeorderApp .order-tab span.curt{
    color:#333;
  }
  .storeorderApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:30px;
    height:2px;
    background:#406DE1;
    bottom:5px;
    left:50%;
    transform: translateX(-50%);
  }
  .storeorderApp .order-item{
    width: 94%;
    display: block;
    margin: 0px auto 10px auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .storeorderApp .order-item .title{
    height: 50px;
    display: block;
    line-height: 51px;
    border-bottom:solid 1px #EBF2FF;
    width:90%;
    margin:0 auto;
  }
  .storeorderApp .order-item .title .address{
    float: left;
    font-size: 16px;
    font-weight:bold;
  }
  .storeorderApp .order-item .title .make{
    float:right;
    font-size:14px;
    color:#406DE1;
  }
  .storeorderApp .order-item .product:after,.storeorderApp .order-item .btn:after,.storeorderApp .goods:after {
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .storeorderApp .order-item .product .names{
    margin:0 auto;
    position:relative;
    width:90%;
  }
  .storeorderApp .order-item .product .names .bt{
    font-size: 15px;
    color: #000;
    width: 100%;
    height:45px;
    line-height: 45px;
  }
  .storeorderApp .order-item .product .names .bt span{
    float:right;
    color:#666;
    margin-right:15px;
    font-size:16px;
  }
  .storeorderApp .order-item .product .names .timer{
    font-size: 14px;
    color: #999;
    padding:10px 0;
    border-bottom:1px #f5f5f5 solid;
  }
  .storeorderApp .order-item .product .names .timer:last-child{
    border-bottom:none;
  }
  .storeorderApp .none{
    text-align:center;
    padding-top:50%
  }
  .storeorderApp .none img{
    width:90%;
    display:block;
    margin:0 auto;
  }

  .storeorderApp .goods .left{
    float:left;
    width:20%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
    height:55px;
    background-size:100% !important
  }
  .storeorderApp .goods .right{
    float:left;
    margin-top:4%;
    width:69%;
    border-bottom:solid 1px #f5f5f5;
    position: relative;
    min-height:52px;
  }
  .storeorderApp .goods .right p{
    letter-spacing:1px;
    font-size:16px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#333;
    width:78%
  }
  .storeorderApp .goods .right p font{
    background:#f00;
    color:#fff;
    border-radius:5px;
    font-size:13px;
    position: relative;
    padding:2px;
    top:-2px;
    margin-right:2px
  }
  .storeorderApp .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:8px;
  }
  .storeorderApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .storeorderApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .storeorderApp .goods .right .price b{
    color: #FF6600;
    font-size:18px;
    font-weight:600;
  }

  .storeorderApp .goods .right .price i{
    color: #FF6600;
    font-size:13px;
    font-style:normal
  }
  
  .storeorderApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .storeorderApp .rylcjs{
    width:92%;
    margin:0 auto;
    height:40px;
    line-height:40px;
    border-top:solid 1px #f5f5f5;
    font-size:15px;
    color:#666
  }
  .rylcjs img{
    float:right;
    width:8px;
    margin-top:14px
  }
  .qrcode {
    padding-bottom:40px
  }
  .qrcode img{
    margin:0 auto;
    width: 132px;
    height: 132px;
    background-color: #fff; 
    padding: 6px;
  }
</style>